import { render } from "./QuotesModule.vue?vue&type=template&id=d2b296be&lang=html"
import script from "./QuotesModule.vue?vue&type=script&lang=js"
export * from "./QuotesModule.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__